import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom'
import {
    CCard,
    CCardBody,
    CCardHeader,
    CButton
} from '@coreui/react'
import Cookies from 'js-cookie'
import { COOKIE_ENUM } from '@webkit/enums/cookie.enum'
import { t } from "i18next"
import { Modal, Button, Form } from "react-bootstrap"
import AuthService from '@services/auth.service'
import { useSpinner } from '@webkit/components/typescript/SpinnerContext';
import { getToastStore } from '@utils/ToastStore';
import DeleteModal from "@webkit/components/typescript/DeleteModal"

const Profile = () => {
    const ctx = getToastStore(); 
    const { showSpinner, hideSpinner } = useSpinner();
    const [formData, setFormData] = useState({
        id: '',
        username: '',
        firstName: '',
        lastName: '',
        gender: '',
        phoneNumber: '',
    })

    const navigate = useNavigate()

    useEffect(() => {
        recoverProfileData()
    }, [])

    const recoverProfileData = () => {
        const userData = Cookies.get(COOKIE_ENUM.HST_USER_PROFILE_DATA)
        if (userData) {
            const user = JSON.parse(userData)
            setFormData({
                id: user.id,
                username: user.username,
                firstName: user.person.name,
                lastName: user.person.surname,
                gender: user.person.gender,
                phoneNumber: user.person.mobileNumber
            })
        }
    }

    const [showPasswordModal, setShowPasswordModal] = useState(false)

    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
    })

    const [passwordError, setPasswordError] = useState('')

    const handlePasswordChange = (e) => {
        const { name, value } = e.target
        setPasswordData({
            ...passwordData,
            [name]: value,
        })
    }

    const handlePasswordSubmit = async (e) => {
        e.preventDefault()
        setPasswordError('')

        if (passwordData.newPassword !== passwordData.confirmPassword) {
            setPasswordError('La nuova password e la conferma non corrispondono')
            return
        }

        try {
            showSpinner()
            const response = await AuthService.changePassword(passwordData.currentPassword, passwordData.newPassword, passwordData.confirmPassword)
            const msg =  response?.message || t("success.password_changed")
            ctx.setToastMsg(msg);
            ctx.setSeeToast(true);
            ctx.setErrorToast(false)
            setShowPasswordModal(false)
            setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' })
        } catch (error) {
            setPasswordError('Errore durante la modifica della password')
            console.error(error)
        }finally{
            hideSpinner()
        }
    }

    const navigation = useNavigate()

    const handleDeleteAccountSubmit = async (e) => {
        e.preventDefault()
    
        try {
            showSpinner()
            const response = await AuthService.deleteUser()
            const msg =  response?.message || t("success.successfull_delete")
            ctx.setToastMsg(msg);
            ctx.setSeeToast(true);
            ctx.setErrorToast(false)
            setShowPasswordModal(false)
            navigation("/login")
        } catch (error) {
            setPasswordError('Errore durante la cancellazione del account')
            console.error(error)
        }finally{
            hideSpinner()
        }
    }

    const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false)

    return (
        <div className="p-4">
            <CCard>
                <CCardHeader>
                    <h5>Profilo Utente</h5>
                </CCardHeader>
                <CCardBody>
                    <div className="p-3 rounded mb-3 bg-light text-dark" >
                        <strong>{t('label.username')}:</strong> {formData.username}
                    </div>
                    <div className="p-3 rounded mb-3 bg-light text-dark">
                        <strong>{t('label.first_name')}:</strong> {formData.firstName}
                    </div>
                    <div className="p-3 rounded mb-3 bg-light text-dark">
                        <strong>{t('label.last_name')}:</strong> {formData.lastName}
                    </div>
                    <div className="p-3 rounded mb-3 bg-light text-dark">
                        <strong>{t('label.select_gender')}:</strong>{' '}
                        {formData.gender === 'male'
                            ? t('label.male')
                            : formData.gender === 'female'
                                ? t('label.female')
                                : t('label.other')}
                    </div>
                    <div className="p-3 rounded mb-3 bg-light text-dark">
                        <strong>{t('label.phone_number')}:</strong> {formData.phoneNumber}
                    </div>

                    {/* Bottone per modificare profilo */}
                    {/* <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                        <CButton
                            className="text-uppercase"
                            style={{ backgroundColor: '#00BFA6', borderColor: '#00BFA6', color: 'white', borderRadius: 25 }}
                            onClick={() => navigate('/settings')}
                        >
                            {t('button.edit_profile')}
                        </CButton>
                    </div> */}
                    <div className="d-flex justify-content-center my-3">
                        <CButton
                            className="text-uppercase"
                            style={{ backgroundColor: '#00BFA6', borderColor: '#00BFA6', color: 'white', borderRadius: 25 }}
                            onClick={() => setShowPasswordModal(true)}>
                            {t('label.modify_password')}
                        </CButton>
                    </div>
                    <div className="d-flex justify-content-center">
                        <CButton
                            className="text-uppercase bg-danger"
                            style={{ color: 'white', borderRadius: 25 }}
                            onClick={() => setShowDeleteAccountModal(true)}>
                            {t('button.delete_account')}
                        </CButton>
                    </div>
                        
                </CCardBody>
            </CCard>
            <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t('label.modify_password')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form onSubmit={handlePasswordSubmit}>
                        <Form.Group className="mb-3" controlId="currentPassword">
                            <Form.Label>{t('label.current_password')}</Form.Label>
                            <Form.Control
                                type="password"
                                name="currentPassword"
                                value={passwordData.currentPassword}
                                onChange={handlePasswordChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="newPassword">
                            <Form.Label>{t('label.new_password')}</Form.Label>
                            <Form.Control
                                type="password"
                                name="newPassword"
                                value={passwordData.newPassword}
                                onChange={handlePasswordChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="confirmPassword">
                            <Form.Label>{t('label.confirm_new_password')}</Form.Label>
                            <Form.Control
                                type="password"
                                name="confirmPassword"
                                value={passwordData.confirmPassword}
                                onChange={handlePasswordChange}
                                required
                            />
                        </Form.Group>

                        {passwordError && <p className="text-danger">{passwordError}</p>}
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        className="text-uppercase"
                        style={{ borderRadius: 25 }}
                        onClick={() => setShowPasswordModal(false)}
                    >
                        {t('button.cancel')}
                    </Button>

                    <Button
                        variant="success"
                        className="text-uppercase"
                        style={{ backgroundColor: '#00BFA6', borderColor: '#00BFA6', color: "white", borderRadius: 25, fontWeight:"500"}}
                        onClick={handlePasswordSubmit}
                    >
                        {t('button.save_password')}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showDeleteAccountModal} onHide={() => setShowDeleteAccountModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t('button.delete_account')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>{t("text.sure_delete")}</div>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        className="text-uppercase"
                        style={{ borderRadius: 25 }}
                        onClick={() => setShowDeleteAccountModal(false)}
                    >
                        {t('button.cancel')}
                    </Button>

                    <Button
                        variant="danger"
                        className="text-uppercase bg-danger"
                        style={{ color: "white", borderRadius: 25 }}
                        onClick={handleDeleteAccountSubmit}
                    >
                        {t('title.delete')}
                    </Button>
                </Modal.Footer>
            </Modal>
            <DeleteModal 
              showModal={showDeleteAccountModal}
              setShowModal={setShowDeleteAccountModal}
              title={t("title.delete_account")}
              deleteFunction={handleDeleteAccountSubmit}
            />
        </div>
    )

}

export default Profile